import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Module } from 'app/models2/administration/module';
import { UtilsServiceService } from 'app/services/utils-service.service';
import { LocalStorageService } from 'brainloper-ui';

@Component({
  selector: 'app-upgrade-plan',
  templateUrl: './upgrade-plan.component.html',
  styleUrls: ['./upgrade-plan.component.scss']
})
export class UpgradePlanComponent implements OnInit {

  public moduleName: string = ""
  public modules: Module[] = this.storage.get<Module[]>('modules')

  constructor(
    private router: Router,
    private utils: UtilsServiceService,
    private activeRoute: ActivatedRoute,
    private storage : LocalStorageService
  ) { }

  ngOnInit(): void {
    let queryParams
    this.activeRoute.queryParamMap
    .subscribe(async(params) => {
      queryParams = { ...params };
    this.moduleName = queryParams.params.modulo

    let colorModule = this.modules.find(x => x.name == this.moduleName)
    let element = document.getElementById("noAccessIcon")
    if (element && colorModule) {
      element.setAttribute("style",`color: ${colorModule.color}` )
    }
  })
}
}
